import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import { GetFabImagesQueryParamsType } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQuery.type';
import { getFabImagesQueryOptions } from '@/modules/adjusterReportModules/adjusterReport/queries/imageFab/getFabImages/getFabImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

const DocumentImagesList = ({
  state,
}: {
  state: GetFabImagesQueryParamsType['state'];
}) => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getFabImagesQueryOptions({
      id: id!,
      state,
      damagedId,
    }),
  );
  return (
    <>
      {!imagesData?.length && !imagesData?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : null}
      {imagesData?.length ? (
        <>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.map((vehicleImages) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: vehicleImages.title?.fa_const,
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
    </>
  );
};

export default DocumentImagesList;
